import clone from 'lodash/clone';

import { TAB_LABELS, removeExtraLabelInfo } from '../sov-queries';

import type { CheckboxesListItem } from 'types';
import type {
  SOVQueryChannelsLocal,
  SOVQuerySearchResultsCheckboxes,
  SOVQuerySearchResultsEndpoint
} from 'modules/insights/sov/types';

export const DEFAULT_CHANNELS_MAP = {
  single: [],
  primary: [],
  secondary: []
};

export const getDefaultChannelsMap = (): SOVQueryChannelsLocal => clone(DEFAULT_CHANNELS_MAP);

const prepareForEndpoint = (results: Array<CheckboxesListItem>): Array<string> => results.filter(item => item.isSelected)
  .map(item => removeExtraLabelInfo((typeof item.label === 'string' ? item.label : null)));

export const prepareQueryResultsForChannelsEndpoint = (
  resultsStandard: Partial<SOVQuerySearchResultsCheckboxes>,
  resultsCustom: Partial<SOVQuerySearchResultsCheckboxes>
): Partial<SOVQuerySearchResultsEndpoint> => {
  const resultsStandardSelected = {};
  const resultsCustomSelected = {};
  const resultsAllSelected = {};

  TAB_LABELS.forEach(tab => {
    resultsStandardSelected[tab] = prepareForEndpoint(resultsStandard[tab]);
    resultsCustomSelected[tab] = prepareForEndpoint(resultsCustom[tab]);
    resultsAllSelected[tab] = resultsStandardSelected[tab].concat(resultsCustomSelected[tab]);
  });

  return resultsAllSelected;
};
